<ng-container
	*ngIf="field.UIOptions?.ArrayFieldOptions && field.UIOptions.ArrayFieldOptions.templateType === 'table' else defaultTemplate;">

	<cv-table-array
		[field]="field"
		[arrayChilds]="arrayChilds"
		(addFormArray)="addFormArray($event)"
		(deleteFormArray)="deleteRowFormArray($event)"
	>

	</cv-table-array>

</ng-container>

<ng-template #defaultTemplate>
	<cv-row-array
		[field]="field"
		[arrayChilds]="arrayChilds"
		(addFormArray)="addFormArray($event)"
		(deleteFormArray)="deleteRowFormArray($event)"
	>
	</cv-row-array>
</ng-template>
